import EventScorekeepingScoreLayout from '@/components/Event/EventScorekeeping/EventScorekeepingScore/EventScorekeepingScoreLayout';

export default function PrivateEventEventIdScorekeepingScoreLayoutRoute() {
  return <EventScorekeepingScoreLayout />;
}
